import React, { useEffect, useRef } from 'react'
import { object, func, string, bool } from 'prop-types'
import { ALLOWED_PROVINCES } from 'utils/constants'
import useScript from 'hooks/useScript'

import Input from 'components/Input'

const AddressComplete = props => {
  const el = useRef(null)
  const { loaded } = useScript(
    `https://ws1.postescanada-canadapost.ca/js/addresscomplete-2.30.min.js?key=${process.env.CANADAPOST_API_KEY}&manualEntry=true`
  )
  useEffect(() => {
    let mounted = true
    const initAddressComplete = () => {
      if (window !== 'undefined') {
        window.addressComplete.listen('load', function (control) {
          if (!mounted) return
          if (props.allowManualEntry) {
            control.listen('manual', () => {
              if (!mounted) return
              props.setFieldValue('isManualEntry', props.allowManualEntry && !props.values.isManualEntry)
              if (props.setFieldError) props.setFieldError('address', undefined)
            })
            control.addManualEntryItem('Enter your address manually')
          }
          control.listen('populate', function (address) {
            if (!mounted) return
            const { FormattedLine1, City, PostalCode, Province, CountryName, SubBuilding, Label } = address
            const addressLabel = Label.replace(/\n|,/gi, ' ')
              .replace(City.toUpperCase(), City)
              .replace(CountryName.toUpperCase(), CountryName)

            props.setFieldValue('address', addressLabel)
            props.setFieldValue('street', FormattedLine1)
            props.setFieldValue('city', City)
            props.setFieldValue('postalCode', PostalCode)
            props.setFieldValue('province', Province)
            props.setFieldValue('country', CountryName)
            props.setFieldValue('subBuilding', SubBuilding)

            props.setFieldValue('geocodedAddress', true)

            if (props.addressOnly) {
              props.setFieldValue('isValid', true)
            }

            if (props.setErrors) {
              if (!ALLOWED_PROVINCES.includes(Province) && !props.quebecValid) {
                props.setErrors({ address: `vype ecommerce is not supported in ${Province}.` })
              } else if (props.userProvince && Province !== props.userProvince) {
                props.setErrors({ address: `Address must be within ${props.userProvince}` })
              }
            }
            if (props.setFieldTouched) {
              props.setFieldTouched('address')
            }
          })
        })
        window.addressComplete.load()
      }
    }

    if (loaded) {
      initAddressComplete()
    }
    return () => {
      mounted = false
    }
  }, [loaded])

  const handleChange = e => {
    props.setFieldValue('address', '')
    props.setFieldValue('street', '')
    props.setFieldValue('city', '')
    props.setFieldValue('postalCode', '')
    props.setFieldValue('province', '')
    props.setFieldValue('country', '')
    props.setFieldValue('subBuilding', '')
    props.setFieldValue('geocodedAddress', false)

    props.onChange(e)
  }

  const handleBlur = () => {
    if (!props.setFieldTouched) return
    props.setFieldTouched('address')
  }

  return (
    <div>
      <Input ref={el} {...props} onChange={handleChange} onBlur={handleBlur} />
    </div>
  )
}

AddressComplete.propTypes = {
  type: string.isRequired,
  label: string.isRequired,
  value: string.isRequired,
  placeholder: string.isRequired,
  name: string.isRequired,
  onChange: func.isRequired,
  onBlur: func,
  setErrors: func.isRequired,
  setFieldValue: func.isRequired,
  setFieldTouched: func,
  setFieldError: func,
  values: object.isRequired,
  quebecValid: bool,
  addressOnly: bool,
  userProvince: string,
  allowManualEntry: bool,
  toggleManualEntry: func
}

export default AddressComplete
